module.exports = __webpack_public_path__ + "static/media/ciss55arch-vertical.55fe5ecc.png";